import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { PasswordComponent } from './components/password/password.component';
import { OtpComponent } from './components/otp/otp.component';
import { SetPasswordComponent } from './components/setPassword/setPassword.component';
import { AuthGuard } from './shared/auth.guard';


const routes: Routes = [
  {
    path: 'main',
    loadChildren: () =>
      import('./main-nav/main-nav.module').then((m) => m.MainNavModule), canActivate: [AuthGuard]
  },
  {
    path: '',
    component: LoginComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent
      }
    ]
  },
  {
    path: '',
    component: PasswordComponent,
    children: [
      {
        path: 'password',
        component: PasswordComponent
      }
    ]
  },
  {
    path: '',
    component: OtpComponent,
    children: [
      {
        path: 'otpverify',
        component: OtpComponent
      }
    ]
  },
  {
    path: '',
    component: SetPasswordComponent,
    children: [
      {
        path: 'set-password',
        component: SetPasswordComponent
      }
    ]
  },
  { path: '**', redirectTo: 'login'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { 

  constructor(){
    console.log("routing constructor");
  
  }
}
